import { DestroyRef, inject, Injectable } from '@angular/core';
import {
  AnalysisResultsTextCommon,
  AnalysisResultsTextCommonClass,
} from '@sleipai/sleip-models';
import { Observable, map } from 'rxjs';
import {
  Firestore,
  collection,
  collectionSnapshots,
} from '@angular/fire/firestore';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class AnalysisResultsTextService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  loadAnalysisResultTexts(): Observable<AnalysisResultsTextCommon[]> {
    const analysisResultTextRef = collection(
      this.firestore,
      `/common/analysisResultsTexts/analysisResultTextDocuments/`
    );

    return collectionSnapshots(analysisResultTextRef).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((snap) => {
        return snap.map((i) => {
          const data = i.data();
          const id = i.id;
          return new AnalysisResultsTextCommonClass({ id, ...data });
        });
      })
    );
  }
}
